export default {
  completion: '{{percent}}% complete',
  pagesValidationProgress: '{{valid}}/{{total}} pages valid ({{percent}}%)',
  pageComplete: 'Complete',
  copyPath: 'Copy path',
  pathCopiedToClipboard: 'Path copied to clipboard',
  subPage: 'Sub page',
  addChildTo: 'Add to {{nodeDefLabel}}',
  addChildToTitle: 'Add new node to {{nodeDefLabel}}',
  addChildToTypes: {
    boolean: 'Boolean',
    code: 'Code',
    coordinate: 'Coordinate',
    date: 'Date',
    decimal: 'Decimal',
    geo: 'Geospatial',
    entity: 'Table or form',
    file: 'File',
    integer: 'Integer',
    taxon: 'Taxon',
    text: 'Text',
    time: 'Time',
    // layout elments
    formHeader: 'Form Header',
  },
  clone: `Clone '{{nodeDefLabel}}'`,
  compressFormItems: `Compress form items for '{{nodeDefLabel}}'`,
  confirmUpdateDependentEnumeratedEntities: `If you continue, some enumerated entities ({{entityDefs}}) will be re-enumerated,  
deleting the existing values inserted into them (if any).  
Continue?`,
  convert: `Convert '{{nodeDefLabel}}'`,
  delete: `Delete '{{nodeDefLabel}}'`,
  edit: `Edit '{{nodeDefLabel}}'`,
  schemaSummary_csv: 'Schema summary (CSV)',
  schemaSummary_xlsx: 'Schema summary (Excel)',
  schemaSummaryAiDescriptions_csv: 'Schema summary + AI descriptions (CSV)',
  schemaSummaryAiDescriptions_xlsx: 'Schema summary + AI descriptions (Excel)',
  hidePages: 'Hide pages',
  showPages: 'Show pages',
  move: `Move '{{nodeDefLabel}}'`,
  movePageUp: 'Move page up',
  movePageDown: 'Move page down',
  formEditActions: {
    preview: 'Preview',
  },
  formEntryActions: {
    confirmDemote: 'Are sure you want to demote this record to {{name}}?',
    confirmPromote: `Are sure you want to **promote this record to {{name}}**?  
You won't be able to edit it anymore`,
    confirmPromoteWithErrors: `**This record contains errors**.  
$t(surveyForm:formEntryActions.confirmPromote)`,
    confirmDelete: 'Are you sure you want to delete this record?\n\n$t(common.cantUndoWarning)',
    closePreview: 'Close preview',
    demoteTo: 'Demote to {{stepPrev}}',
    promoteTo: 'Promote to {{stepNext}}',
    step: 'Step {{id}} ({{name}})',
  },
  nodeDefEditFormActions: {
    columns: 'Columns',
    confirmConvert: 'Convert the attribute "{{name}}" into "{{toType}}"?',
    confirmDelete:
      'Are you sure you want to permanently delete this node definition: {{ name }}?\n\n$t(common.cantUndoWarning)',
  },
  nodeDefCode: {
    code: '$t(common.code)',
    label: '$t(common.label)',
    typeCodeOrLabel: 'Type code or label',
    option: 'Option {{value}}',
  },
  nodeDefBoolean: {
    labelValue: {
      trueFalse: {
        true: '$t(common.true)',
        false: '$t(common.false)',
      },
      yesNo: {
        true: '$t(common.yes)',
        false: '$t(common.no)',
      },
    },
  },
  nodeDefCoordinate: {
    coordinate: 'Coordinate',
    srs: 'SRS',
    x: 'X',
    y: 'Y',
    showOnMap: 'Show on map',
    accuracy: 'Accuracy',
    altitude: 'Altitude',
    altitudeAccuracy: 'Altitude accuracy',
  },
  nodeDefGeo: {
    confirmDelete: 'Delete this Geospatial value?',
    geoJSON: 'GeoJSON',
    invalidGeoJsonFileUploaded: 'Invalid GeoJSON file uploaded',
  },
  nodeDefEntityForm: {
    addNewEntity: 'Add new {{name}}',
    confirmDelete: 'Are you sure you want to delete this entity?',
    select: 'Select a {{name}}:',
    selectedEntity: 'Selected {{name}}:',
  },
  nodeDefTaxon: {
    code: '$t(common.code)',
    scientificName: 'Scientific name',
    vernacularName: 'Vernacular name',
    vernacularNameAlwaysIncludedIfSingle: 'Vernacular name always included if only one',
    vernacularNameAlwaysIncludedIfSingleInfo: `- **Enabled**: If this option is enabled and a taxon has only one vernacular name defined, that vernacular name will automatically be stored with the data when the taxon is selected.  
- **Disabled**: only the taxon code and scientific name will be stored, even if the taxon has a single vernacular name.`,
    vernacularNameSelectionKept: 'Vernacular name selection kept',
    vernacularNameSelectionKeptInfo: `- **Enabled**: when a taxon is selected using a vernacular (common) name, the specific vernacular name used for the search will also be stored in the data.  
- **Disabled**: only the taxon code and scientific name will be stored, regardless of which vernacular name was used during the search.  
In Arena Mobile:  
- **Enabled**: each vernacular name appears as a separate item in the search results list.
- **Disabled**: all vernacular names for a taxon are grouped together and displayed alongside the taxon (combined in a single entry). As a result, the autocomplete list contains fewer items.`,
    visibleFields: 'Visible fields',
  },
  nodeDefFile: {
    errorLoadingPreview: 'Error loading preview',
    fileUuid: 'File uuid',
    fileName: 'File name',
    locationInformationNotFound: 'Location information not found in the file',
  },
  nodeDefsTreeSelectMode: {
    allNodeDefs: 'All nodes',
    onlyPages: 'Only pages',
  },
  step: {
    entry: 'Entry',
    cleansing: 'Cleansing',
    analysis: 'Analysis',
  },
  cloneFromAnotherSurvey: {
    title: 'Clone Node From Another Survey',
    expandToLoadNodes: 'Expand to load nodes',
    loadingSurveyNodes: 'Loading survey nodes...',
    errorLoadingSurveyNodes: 'Error loading survey nodes',
    noNodesAvailable: 'No nodes available',
    loadingSurveys: 'Loading surveys...',
    noSurveysAvailable: 'No surveys available',
    sourceNode: 'Source node',
    targetEntityCurrentSurvey: 'Target entity (current survey)',
  },
  confirmNodeDelete: 'Are you sure you want to delete this {{nodeDefType}} ({{nodeDefLabel}})?',
  downloadPrintableDocument: 'Download printable document (Word)',
  downloadPrintableDocumentPdf: 'Download printable document (PDF)',
  printableExport: {
    title: 'Export printable document',
    exportDocument: 'Export Document',
    format: 'Format',
    formats: {
      pdf: 'PDF',
      docx: 'Word',
    },
    scope: 'Content',
    scopes: {
      full: 'Full survey',
      currentPage: 'Current page only',
    },
    currentPageHint: 'Current page: {{entityLabel}}',
    currentPageUnavailable:
      'Unable to determine the current page instance. Navigate to a specific page or export the full survey.',
    orientation: 'Page orientation',
    orientations: {
      portrait: 'Portrait',
      landscape: 'Landscape',
    },
    download: 'Download',
  },
  exportLabels_csv: 'Export labels (CSV)',
  exportLabels_xlsx: 'Export labels (Excel)',
  importLabels: 'Import labels from Excel or CSV',
  aiTranslateLabels: 'AI: Translate labels',
  nodeDefsTranslation: {
    apply: 'Apply Translations',
    applySuccess: 'Translations applied successfully',
    aiSuggestion: 'AI',
    current: 'Current',
    custom: 'Custom',
    defaultDescription: 'Default description',
    defaultLabel: 'Default label',
    path: 'Path',
    showDescriptions: 'Show descriptions',
    title: 'Translate Node Definition Labels',
  },
}
